export default __webpack_public_path__ + "static/media/AGMTechnologies.fd139a43.png";